import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#7cc233',
        secondary: '#141439',
        error: '#ef4444',
        muted: '#65656C'
      },
      dark: {
        primary: '#7cc233',
        secondary: '#141439',
        error: '#ef4444',
        muted: '#65656C'
      }
    }
  }
})
